"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectibleServerAPI = void 0;
var frontend_provider_types_1 = require("@manifoldxyz/frontend-provider-types");
var COLLECTIBLE_BACKEND = {
    1: 'https://collectible.api.manifoldxyz.dev',
    5: 'https://goerli.collectible.api.manifoldxyz.dev',
    137: 'https://matic.collectible.api.manifoldxyz.dev',
};
var CollectibleServerAPI = /** @class */ (function () {
    function CollectibleServerAPI(collectibleServerURL) {
        var _this = this;
        if (collectibleServerURL) {
            this.collectibleServerURL = collectibleServerURL;
        }
        else {
            var onEthereumChainChanged = function () {
                _this.collectibleServerURL = COLLECTIBLE_BACKEND[window.ManifoldEthereumProvider.chainId()];
            };
            window.addEventListener(frontend_provider_types_1.CHAIN_CHANGED, onEthereumChainChanged);
            window.addEventListener(frontend_provider_types_1.PROVIDER_CHANGED, onEthereumChainChanged);
            onEthereumChainChanged();
        }
    }
    CollectibleServerAPI.prototype.setAccessToken = function (accessToken) {
        this.accessToken = accessToken;
    };
    CollectibleServerAPI.prototype.clearAccessToken = function () {
        this.accessToken = undefined;
    };
    CollectibleServerAPI.prototype.getHeaders = function () {
        var headers = {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        };
        if (this.accessToken) {
            headers.Authorization = "Bearer ".concat(this.accessToken);
        }
        return headers;
    };
    CollectibleServerAPI.prototype.fetch = function (path, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, queryString, requestOptions, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.collectibleServerURL + path;
                        if (options.query) {
                            queryString = new URLSearchParams(options.query).toString();
                            url = url + '?' + queryString;
                        }
                        requestOptions = __assign({ method: 'GET', headers: this.getHeaders() }, options);
                        return [4 /*yield*/, fetch(url, requestOptions)];
                    case 1:
                        response = _a.sent();
                        if (response.status >= 400 && response.status <= 500) {
                            console.error(response);
                            throw new Error("Received status '".concat(response.status, "' from server"));
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CollectibleServerAPI.prototype.post = function (path, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var url, queryString, requestOptions, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = this.collectibleServerURL + path;
                        if (options.query) {
                            queryString = new URLSearchParams(options.query).toString();
                            url = url + '?' + queryString;
                        }
                        requestOptions = __assign({ method: 'POST', headers: this.getHeaders() }, options);
                        if (options.body) {
                            requestOptions.body = JSON.stringify(options.body);
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fetch(url, requestOptions)];
                    case 2:
                        response = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        if (process.env.NODE_ENV === 'development') {
                            console.error('e', e_1);
                        }
                        throw e_1;
                    case 4:
                        if (response.status !== 200) {
                            console.error(response);
                            throw new Error("Received status '".concat(response.status, "' from server"));
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    CollectibleServerAPI.prototype.getPresaleEligibilty = function (collectibleId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post("/presale/".concat(collectibleId))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleServerAPI.prototype.getPresaleValidation = function (collectibleId, requestorAddress, recaptchaResponse, requestedAmount) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post("/presale/validate/".concat(collectibleId), {
                            body: {
                                requestorAddress: requestorAddress,
                                requestedAmount: requestedAmount,
                                'g-recaptcha-response': recaptchaResponse,
                            },
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleServerAPI.prototype.getValidation = function (collectibleId, requestorAddress, recaptchaResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.post("/validate/".concat(collectibleId), {
                            body: {
                                requestorAddress: requestorAddress,
                                'g-recaptcha-response': recaptchaResponse,
                            },
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleServerAPI.prototype.getClaimEligibility = function (collectibleId, requestorAddress, requestedAmount) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch("/collectible/".concat(collectibleId, "/claims?address=").concat(requestorAddress).concat(requestedAmount ? "&amount=".concat(requestedAmount) : ''))];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleServerAPI.prototype.fetchCollectionData = function (collectibleId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch("/collectible/".concat(collectibleId))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    CollectibleServerAPI.prototype.fetchCollectionPricingData = function (collectibleId, pricingType) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch("/collectible/".concat(collectibleId, "/pricing?type=").concat(pricingType))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    CollectibleServerAPI.prototype.fetchToken = function (collectibleId, tokenAddress, tokenId) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.fetch("/collectible/".concat(collectibleId, "/token/").concat(tokenAddress, "/").concat(tokenId))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    return CollectibleServerAPI;
}());
exports.CollectibleServerAPI = CollectibleServerAPI;
